import { Grid } from '@/common/grid/Grid';
import { useDependentKey } from '@/common/hooks/key/useDependentKey';
import { useRsrc } from '@/common/rsrc/RsrcContext';
import { useEffect, useRef, useState } from 'react';

export const McoPhsCapTable = ({ formValues }) => {

    const { mcoInvId, prodIds, periodIds } = formValues;

    const gridRef = useRef();

    const rsrc = useRsrc();

    const [data, setData] = useState();

    const [fieldDefs, setFieldDefs] = useState();
    const [isGridReady, setIsGridReady] = useState(false);

    useEffect(() => {
        if (!mcoInvId) {
            return;
        }

        setIsGridReady(false);

        const reqParam = {
            mcoInvId,
            prodIds,
            periodIds

        };

        rsrc.data('sc', 'MCO_PHS_CAP_TABLE_FIELD_DEFS_DATA_PLUGIN', reqParam).then(res => {
            setFieldDefs(res);
        });

    }, [mcoInvId, prodIds, periodIds]);

    useEffect(() => {
        if (!mcoInvId) {
            return;
        }

        const reqParam = {
            mcoInvId,
            prodIds,
            periodIds

        };

        rsrc.data('sc', 'MCO_PHS_CAP_TABLE_DATA_PLUGIN', reqParam).then(res => {
            setData(res);
        });
    }, [mcoInvId, prodIds, periodIds]);

    const onGridReady = () => {
        setIsGridReady(true);
    }

    useEffect(() => {
        if (isGridReady && gridRef.current && data) {
            gridRef.current.setDataSource(data);
        }
    }, [isGridReady, data]);

    const gridKey = useDependentKey(fieldDefs);

    if (!fieldDefs || !data) {
        return;
    }

    return (
        <Grid
            key={gridKey}
            ref={gridRef}
            gridOptions={{
                fieldDefs,
                rowModelType: 'clientSide',
                statusBar: null
            }}
            events={{ onGridReady}}
        />
    );
}